import {
  IDeleteSearchHistoryParams,
  IGetSymbolDetailParams,
  IHideMarketSymbolParams,
  IMarketSymbolCategory,
  ISearchSymbolsParams,
  ISymbol,
  ISymbolDetail
} from '@aqx-core/common/api/market';
import { request } from '@aqx-core/common/request';

export default {
  hideMarketSymbols: (params: IHideMarketSymbolParams) => request.post('/api/market/v1/hide', params),
  marketSymbolCategories: (signal?: AbortSignal) =>
    request.get<IMarketSymbolCategory>('/api/market/v1/symbol/category', { signal }),
  symbolDetail: (params: IGetSymbolDetailParams, signal?: AbortSignal) =>
    request.get<ISymbolDetail>('/api/market/v1/symbol/detail', { params, signal }),
  symbolOrderDetail: (params: IGetSymbolDetailParams, signal?: AbortSignal) =>
    request.get<ISymbolDetail>('/api/market/v1/symbol/order/detail', { params, signal }),
  symbols: () => request.get<ISymbol[]>('/api/market/v1/symbols'),
  allSymbols: () => request.get<ISymbol[]>('/api/market/v1/symbols/all'),
  searchSymbol: (params: ISearchSymbolsParams, signal?: AbortSignal) =>
    request.get<ISymbol[]>('/api/market/v1/symbols/search', { params, signal }),
  symbolSearchHistories: () => request.get<ISymbol[]>('/api/market/v1/symbols/search/history'),
  deleteSearchHistories: (params?: IDeleteSearchHistoryParams) =>
    request.delete<boolean>('/api/market/v1/symbols/search/history', { params }),
  updateSearchHistories: (params: ISearchSymbolsParams) =>
    request.patch<boolean>('/api/market/v1/symbols/search/history', params)
};
